module.exports = __webpack_public_path__ + "static/media/DataDeletion.b6fa7ea0.md";